const Radius = {
    dom: null,
    maxScroll: 500,
    maxBorderRadius: 0,

    handleScroll() {
        const scrollTop = window.scrollY;
        const progress = Math.min(scrollTop / Radius.maxScroll, 1);
        const currentBorderRadius = progress * Radius.maxBorderRadius;

        Radius.dom.style.borderRadius = `0 0 ${currentBorderRadius}px ${currentBorderRadius}px`;
    },

    init() {
        const hero = document.querySelector(".HeroHome");
        const themeElement = document.querySelector(".theme--Codent");

        if (hero && themeElement) {
            const style = getComputedStyle(themeElement);
            Radius.maxBorderRadius = Number.parseFloat(style.getPropertyValue("--radiusLayout")) || 0;
            Radius.dom = hero;

            window.addEventListener("scroll", Radius.handleScroll);
        }
    }
};

export default Radius;